import raw from "../../data/athlete-media.json";
import { validateSiteContent } from "./validateSiteContent";
import type { SiteContent } from "./types";

export const siteContent: SiteContent = validateSiteContent(raw);
